import React from "react";
import "./Termsconditions.css";
import Common_Banner from "../common-components/common_banner/Common_Banner"; // ✅ Import banner
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";

const Termsconditions = () => {
  return (
    <div className="terms-wrapper">
      {/* ✅ Replaced old banner with Common_Banner */}
      {/* <Common_Banner
        imgSrc="/assets/images/termsandconditions/terms.png"
        title="Terms & Conditions"
      /> */}

      <Common_Banner_2
        imgSrc="/assets/images/about_us/banner/Banner-01.png"
        title_text="Terms & Conditions"
      />

      <div className="container  mt-5">
        {/* Content Section */}


        <h1>Terms & Conditions</h1>
        <p class="updated">Last Updated: 11-06-2026</p>
        <p> Welcome to the website of <strong>Nutripair India Pvt Ltd</strong> ("Company," "we," "our," or "us"). By accessing,
          browsing, or using this Website ("www.nutricos.in"), you acknowledge that you have read, understood, and agree to be
          bound by these Terms & Conditions. If you do not agree with any part of these Terms, please refrain from using the
          Website. </p>
        <h2>1. Use of Website</h2>
        <p> You agree to use this Website only for lawful purposes and in compliance with all applicable laws, regulations, and
          these Terms & Conditions. </p>
        <p>You shall not:</p>
        <ul>
          <li>Use the Website in any manner that violates any applicable law or regulation.</li>
          <li>Attempt to gain unauthorized access to any part of the Website, servers, databases, or systems connected to the
            Website.</li>
          <li>Introduce viruses, malware, spyware, or any other harmful code.</li>
          <li>Copy, reproduce, distribute, modify, or exploit any Website content without prior written consent from the
            Company.</li>
          <li>Engage in any activity that may disrupt or interfere with the proper functioning of the Website.</li>
        </ul>
        <h2>2. Intellectual Property Rights</h2>
        <p> All content available on this Website, including but not limited to: </p>
        <ul>
          <li>Logos</li>
          <li>Trademarks</li>
          <li>Brand names</li>
          <li>Product images</li>
          <li>Graphics</li>
          <li>Text</li>
          <li>Videos</li>
          <li>Designs</li>
          <li>Software and Website layout</li>
        </ul>
        <p> is the exclusive property of Nutripair India Pvt Ltd or its licensors and is protected under applicable intellectual
          property laws. </p>
        <p> No content from this Website may be copied, reproduced, republished, uploaded, posted, transmitted, or distributed
          without prior written permission from the Company. </p>
        <h2>3. Product Information and Marketplace Redirection</h2>
        <p> This Website is intended to provide information about Nutripair products and brands. At present, Nutripair India Pvt
          Ltd does not directly sell products through this Website and does not operate a direct-to-consumer (D2C) e-commerce
          platform on this Website. </p>
        <p> Products displayed on the Website may include links that redirect users to third-party marketplaces and delivery
          platforms such as Amazon, Flipkart, Blinkit, or other authorized retail partners where purchases may be completed.
        </p>
        <p> By clicking on such links and proceeding to purchase products through third-party platforms, you acknowledge and
          agree that: </p>
        <ul>
          <li>Any purchase transaction is conducted directly between you and the respective third-party marketplace or seller.
          </li>
          <li>Nutripair India Pvt Ltd is not the seller, retailer, merchant of record, payment processor, or fulfillment partner
            for such transactions.</li>
          <li>Product pricing, discounts, offers, availability, delivery timelines, shipping charges, return policies, exchange
            policies, and payment terms are determined solely by the respective marketplace or seller.</li>
          <li>Nutripair India Pvt Ltd does not guarantee the availability of products on any third-party platform.</li>
          <li>Any issues relating to order placement, payment processing, shipping, delivery, returns, refunds, cancellations,
            or customer service must be addressed directly with the relevant marketplace or seller.</li>
        </ul>
        <p> While we make reasonable efforts to ensure that product descriptions, nutritional information, specifications, and
          images displayed on the Website are accurate and up to date, we do not warrant that all information is complete,
          accurate, reliable, or error-free at all times. </p>
        <p> The Company reserves the right to modify, update, add, remove, or discontinue product listings and marketplace links
          without prior notice. </p>
        <h2>4. Nutritional Information Disclaimer</h2>
        <p> The information provided on this Website is intended solely for general informational and educational purposes. </p>
        <p> Our products and the information presented on this Website are not intended to diagnose, treat, cure, prevent, or
          mitigate any disease or medical condition. Nutritional information should not be considered medical advice. </p>
        <p> Users are advised to consult qualified healthcare professionals, nutritionists, or medical practitioners before
          making dietary or health-related decisions. </p>
        <h2>5. Third-Party Websites and Marketplace Links</h2>
        <p> This Website may contain links to third-party websites, marketplaces, services, or resources for your convenience,
          including but not limited to Amazon, Flipkart, Blinkit, social media platforms, and other retail partners. </p>
        <p> Nutripair India Pvt Ltd does not own, operate, control, or manage such third-party platforms and does not endorse or
          guarantee: </p>
        <ul>
          <li>The content available on third-party websites.</li>
          <li>Product availability or pricing.</li>
          <li>Delivery timelines or service quality.</li>
          <li>Privacy practices or data handling procedures.</li>
          <li>Terms and conditions of third-party platforms.</li>
          <li>Accuracy of information provided by third parties.</li>
        </ul>
        <p> Your interactions with any third-party website or marketplace are governed solely by the terms, conditions, and
          privacy policies of those platforms. Accessing and using third-party websites is entirely at your own risk. </p>
        <h2>6. Limitation of Liability</h2>
        <p> To the maximum extent permitted by applicable law, Nutripair India Pvt Ltd shall not be liable for any direct,
          indirect, incidental, consequential, special, exemplary, or punitive damages arising from or related to: </p>
        <ul>
          <li>Use or inability to use the Website.</li>
          <li>Errors or omissions in Website content.</li>
          <li>Website interruptions, downtime, or technical failures.</li>
          <li>Unauthorized access to or alteration of user information.</li>
          <li>Reliance on information provided on the Website.</li>
          <li>Purchases made through third-party marketplaces or retailers.</li>
          <li>Product availability, pricing, delivery delays, cancellations, returns, refunds, or disputes involving third-party
            sellers or platforms.</li>
          <li>Loss of profits, revenue, business opportunities, goodwill, or data.</li>
        </ul>
        <p> Your use of the Website and any third-party marketplace links is entirely at your own risk. </p>
        <h2>7. User Submissions</h2>
        <p> Any feedback, suggestions, reviews, comments, inquiries, ideas, or other communications submitted through the
          Website shall become the property of the Company unless otherwise agreed in writing. </p>
        <p>By submitting content, you represent and warrant that:</p>
        <ul>
          <li>You own or have the necessary rights to submit such content.</li>
          <li>The content does not infringe any intellectual property rights or other legal rights of third parties.</li>
          <li>The content is not unlawful, defamatory, misleading, fraudulent, or offensive.</li>
        </ul>
        <p> The Company reserves the right to remove, edit, or refuse any user-submitted content at its sole discretion. </p>
        <h2>8. Modification of Terms</h2>
        <p> Nutripair India Pvt Ltd reserves the right to revise, amend, or update these Terms & Conditions at any time without
          prior notice. </p>
        <p> Any modifications shall become effective immediately upon posting on the Website. Continued use of the Website
          following such changes constitutes acceptance of the revised Terms. </p>
        <p>Users are encouraged to review these Terms periodically.</p>
        <h2>9. Governing Law and Jurisdiction</h2>
        <p> These Terms & Conditions shall be governed by and construed in accordance with the laws of India. </p>
        <p> Any disputes arising out of or relating to these Terms or the use of the Website shall be subject to the exclusive
          jurisdiction of the competent courts located in Pune, Maharashtra, India. </p>
        <h2>10. Contact Information</h2>
        <div class="contact-box">
          <p><strong>Nutripair India Pvt Ltd</strong></p>
          <p><strong>Email:</strong> nutripair@nutripair.in, nutripair.india@gmail.com</p>
          <p><strong>Phone:</strong> +91 9604663885</p>
          <p><strong>Address:</strong> Paygude Compound, 4/2/762, Bhairavnath Nagar, Kondhwe Dhawde, Pune, Maharashtra - 411023,
            India</p>
        </div>

      </div>
    </div>
  );
};

export default Termsconditions;
